import React, { useEffect, useState } from 'react';

export default function TextController({ index, delay, children, ...props }) {
	const [childrenList, setChildrenList] = useState([]);

	useEffect(() => {
		const timer = setTimeout(() => {
			handleAddNext();
		}, delay);

		return () => clearTimeout(timer);
	}, []);

	const handleAnimationEnd = () => {
		if(index < children.length) {
			handleAddNext();
		}
	};

	const handleAddNext = () => {
		if(children[index]) {
			const clonedEl = React.cloneElement(
				children[index],
				{
					onNext: time => handleAnimationEnd(time, children[index]),
				}
			);
			setChildrenList(prev => [...prev, clonedEl]);
			index++;
		}
	};

	return <div {...props}>{childrenList}</div>;
}
